import React, { useEffect } from "react";
import LocalesConfig from "./Localization/LocalesConfig";
import { store } from "./Services/redux/store";
import { Provider } from "react-redux";
import Routes from "./Routes";
import { Toaster } from "react-hot-toast";

import { Auth } from "./Services/redux/reducer";
function App() {
  let lng = sessionStorage.getItem("preferredLanguage");
  let dir = sessionStorage.getItem("direction");

  useEffect(() => {
    if (!lng) {
      sessionStorage.setItem("preferredLanguage", "en");
    }
    if (!dir) {
      sessionStorage.setItem("direction", "ltr");
    }
  }, [lng, dir]);

  LocalesConfig(lng);

  const sessionStorageState = JSON.parse(sessionStorage.getItem("user"));

  if (
    sessionStorageState &&
    sessionStorageState.islogin &&
    sessionStorageState.user
  ) {
    store.dispatch(
      Auth({
        user: sessionStorageState.user,
        islogin: sessionStorageState.islogin,
        role: sessionStorageState.role,
      })
    );
  }
  return (
    <Provider store={store}>
      <Toaster />
      <html dir={dir} className={lng === "ar" ? `Majalla` : ""}>
        <Routes />
      </html>
    </Provider>
  );
}

export default App;
